import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyC3F_-AR8LC6mlv4vtuB4lUZXwK89h6-t0',
  authDomain: 'moa2021-f9c96.firebaseapp.com',
  databaseURL: 'https://moa2021-f9c96-default-rtdb.firebaseio.com',
  projectId: 'moa2021-f9c96',
  storageBucket: 'moa2021-f9c96.appspot.com',
  messagingSenderId: '915809940726',
  appId: '1:915809940726:web:401acfb0eb2e9ab5cce8d7',
  measurementId: 'G-EFFTRVPNMM',
}

firebase.initializeApp(firebaseConfig)
firebase.analytics()

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const getDbRef = (dbRef) => {
  const envDbRef = `${process.env.NODE_ENV === 'production' ? 'production' : 'local'}/${dbRef}`
  return firebaseDb.ref(envDbRef)
}

const ChatDb = getDbRef('chat')
const HallOneDb = getDbRef('Hall_A_Question')
const HallTwoDb = getDbRef('Hall_B_Question')
const ChatMcDb = getDbRef('chatMc')
const NoticeDb = getDbRef('notice')
const NotificationDb = getDbRef('pushNotifications')

const getUniqueSessionDb = (uid) => getDbRef(`uniqueSession/${uid}`)
const getUserCountDb = (uid, path) => getDbRef(`userCount/${path}/${uid}`)
const getUserSessionDb = (uid) => getDbRef(`userSessions/${uid}`)
const getOnlineStatusDb = (uid) => getDbRef(`onlineStatus/${uid}`)
const getLiveCheckInSessionDb = (hallNumber) => getDbRef(`liveCheckInSession/hall-${hallNumber}`)

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  HallOneDb,
  HallTwoDb,
  ChatMcDb,
  NoticeDb,
  NotificationDb,
  getUniqueSessionDb,
  getUserCountDb,
  getUserSessionDb,
  getOnlineStatusDb,
  getLiveCheckInSessionDb,
}
